'use client';

import { TtWid } from '@byted-ucenter/ttwid';
import { useMountEffect } from '@react-hookz/web';
import cookieBanner from '@tiktok-fe/web-cookie-banner';

export function CookieBanner({ locale }: { locale: string }) {
  useMountEffect(async () => {
    const webId = new TtWid({
      aid: 1583, // TTAM app id
      service: 'ads.tiktok.com',
      unionHost: 'https://www.tiktok.com',
      host: 'https://ads.tiktok.com',
      needFid: false,
    });

    await webId.checkWebId();
    // https://bytedance.larkoffice.com/wiki/FMoBwttApiL8ZhkJBTKcJgjrn4f
    await cookieBanner.loadCookieBanner({
      locale,
      consentApiDomain: 'https://ads.tiktok.com',
    });
  });
  return null;
}
